<template lang="pug">
	.network-show--affiliated-shows--list.flex-col.space
		ListView.full-width(
			ref="list",
			initialView="table",
			:getTotal="(r) => affiliatedOnly ? affiliatedShows.length : r.TotalNumberOfRecords",
			:getItems="(r) => affiliatedOnly ? r : r.Results",
			:getData="affiliatedOnly ? getAffilaitedShows : $Data.getAvailableNetworkShows",
			:columns="columns",
			:filterRow="true",
			:remoteSorting="true",
			:hideViewsSelection="true",
			:autoFit="true",
			:heightDelta="30",
			:showColumnHeaders="false"
		)
			.flex-row.space-large.align-center(slot="left-actions")
				.font-big.upper.grey.tb-padding {{$tCaption('Network shows')}}
			.flex-row.space-large.align-center(slot="right-actions")
				Switcher.upper(:text="$tCaption('Affiliated only')", :value.sync="affiliatedOnly")
			template(v-slot:displayValue="{ data }")
				.show-item.flex-row.flex1.space-medium
					.show-logo(v-if="data.LogoUrl || data.PictureUrl", :style="{ '--img': `url('${data.LogoUrl || data.PictureUrl}')` }")
					.flex-col.space.wrap.flex-1
						.flex-row.align-center.space
							.font-big {{data.Name || $tCaption('Show')}}
							.grey(v-if="data.Subname") ({{data.Subname}})
						.flex-row.space-large.align-center.grey
							.flex-row.space-medium.align-center
								.flex-row.space(v-if="data.ScheduleStartDateGmt")
									.grey {{$tCaption('Starts:')}}
									span {{$moment(data.ScheduleStartDateGmt).format('LL')}}
								.flex-row.space(v-if="data.ScheduleEndDateGmt")
									.grey {{$tCaption('Ends:')}}
									span {{$moment(data.ScheduleEndDateGmt).format('LL')}}
							.flex-row.align-center.space(v-if="data.Schedule && data.Schedule.RecurrencePattern")
								fas(icon="clock")
								span {{getReadableStringFromRRule(data.Schedule.RecurrencePattern)}}
						span(v-if="data.Description") {{data.Description}}
						.flex-row.justify
							.left
							.right.flex-row.space.align-center
								template(v-if="isAffiliatedShow(data)")
									DxButton(icon="fas fa-times", :text="$tCaption('Remove')", type="danger", @click="removeAffiliatedShow(data)", stylingMode="text")
									DxButton(icon="fas fa-cog", :text="$tCaption('Manage')", type="normal", @click="manageShow(data)")
								DxButton(v-else icon="fas fa-arrow-right", :text="$tCaption('Affiliate')", type="default", @click="affiliateShow(data)")
		Loader(v-if="isLoading", text="", :fullscreen="true")
		Popup(v-if="managePopup.visible", :popupVisible.sync="managePopup.visible", :title="$tCaption('Manage show \"SHOW_NAME\"').replace(/SHOW_NAME/g, managePopup.show.Name)", :width="540", :height="440",
			:closeOnOutsideClick="false")
			.network-show--affiliated-shows--list.content.flex-col.space-medium(:class="{ 'disabled-controls': managePopup.loading }")
				.no-data(v-if="managePopup.stations && !managePopup.stations.length") {{$tCaption('You do not have any stations.')}}
				.station.flex-col.space-medium(v-if="managePopup.stations", v-for="station in managePopup.stations")
					template(v-for="schedule in [stationSchedule(station)]")
						.flex-row.justify.space.align-center
							.flex-row.space.align-center
								.font-lg {{station.Name}}
								Loader(v-if="schedule && schedule.__updating", text="")
							.flex-row.space
								DxButton(v-if="!schedule", :text="$tCaption('Add to station')", @click="addShowToStation(station)")
								DxButton(v-else, :text="$tCaption('Remove show from station')", @click="removeShowFromStation(schedule)", type="danger", stylingMode="text")
						template(v-if="schedule")
							.flex-row.space-medium
								EditableLabelField.flex-1(:caption="$tCaption('Starts')", :value.sync="schedule.Schedule.StartDate", @change="saveSchedule(schedule)", type="date")
								EditableLabelField.flex-1(:caption="$tCaption('Ends')", :value.sync="schedule.Schedule.EndDate", @change="saveSchedule(schedule)", type="date")
							.flex-col
								.font-small.upper.grey {{$tCaption('Reccurrence')}}
								RRuleField.font-lg(:value="schedule.Schedule.RecurrencePattern", @save="v => setSchedulePattern(schedule, v)", :editable="true")
				Loader(v-if="managePopup.loading", text="", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="managePopup.visible = false")
</template>

<script>
	import _ from 'lodash';
	import ListView from 'app-core/ListView.vue';
	import DxButton from 'devextreme-vue/button';
	import { getReadableStringFromRRule } from 'app-core/rrule';
	import Loader from 'app-core/Loader.vue';
	import Switcher from 'app-core/Switcher.vue';
	import Popup from 'app-core/Popup.vue';
	import RRuleField from 'app-core/RRuleField.vue';
	import EditableLabelField from 'app-core/EditableLabelField.vue';

	export default {
		translationCategory: 'networkShow.AffiliatedShowsList',
		name: 'network-show--affiliated-shows--list',
		components: { ListView, DxButton, Loader, Switcher, Popup, RRuleField, EditableLabelField },
		data() {
			return {
				columns: [
					{ dataField: 'Name', cellTemplate: 'displayValue', caption: this.$tCaption('Name') }
				],
				isLoading: false,
				affiliatedShows: [],
				affiliates: [],
				affiliatedOnly: false,
				managePopup: {
					visible: false,
					loading: false,
					stations: null,
					show: null,
					affiliate: null,
					schedules: []
				}
			};
		},
		watch: {
			affiliatedOnly() {
				this.$refs.list.reload();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.affiliatedShows = this;
			this.loadAffiliatedShows();
		},
		methods: {
			setSchedulePattern(schedule, pattern) { 
				schedule.Schedule.RecurrencePattern = pattern;
				this.saveSchedule(schedule);
			},
			async saveSchedule(schedule) {
				this.$set(schedule, '__updating', (schedule.__updating || 0) + 1);
				if (schedule.__updating > 1) return;
				return this.$Data.createUpdateNetworkShowAffiliateSchedule(_.omit(schedule, ['ScheduleStartDateGmt', 'ScheduleEndDateGmt', '__updating'])).finally(() => {
					const reSave = schedule.__updating > 1;
					this.$set(schedule, '__updating', 0);
					if (reSave) {
						this.saveSchedule(schedule);
					}
				});
			},
			stationSchedule(station) {
				return this.managePopup.schedules.find(f => f.Station?.Oid === station?.Oid);
			},
			loadAffiliateSchedules() {
				this.managePopup.loading++;
				this.managePopup.schedules = [];
				this.$Data.getNetworkShowAffiliateSchedules(0, 20, void 0, this.managePopup.affiliate.Oid)
					.then(r => this.managePopup.schedules = r?.Results || [])
					.finally(() => this.managePopup.loading--);
			},
			addShowToStation(station) {
				this.managePopup.loading++;
				this.$Data.createUpdateNetworkShowAffiliateSchedule({
					Affiliate: _.pick(this.managePopup.affiliate, ['Oid']),
					Station: _.pick(station, ['Oid'])
				})
				.then(r => {
					if (r?.Success !== false) {
						this.managePopup.schedules.push(r?.Data);
					}
				})
				.finally(() => this.managePopup.loading--);
			},
			removeShowFromStation(schedule) {
				return this.$confirm(void 0, this.$tCaption('Do you want to remove \"SHOW_NAME\" from station?').replace(/SHOW_NAME/g, this.managePopup.show.Name)).then(() => {
					const idx = this.managePopup.schedules.findIndex(f => f.Oid === schedule.Oid);
					if (idx >= 0) {
						this.managePopup.schedules.splice(idx, 1);
					}
					this.$Data.deleteNetworkShowAffiliateSchedule(schedule.Oid);
				})
			},
			manageShow(show) {
				this.managePopup.visible = false;
				this.managePopup.show = show;
				this.managePopup.affiliate = this.affiliates.find(f => f.NetworkShow.Oid === show.Oid);
				this.loadStations();
				this.loadAffiliateSchedules();
				this.$nextTick(() => this.managePopup.visible = true);
			},
			async loadStations() {
				if (this.managePopup.stations) return;
				this.managePopup.loading++;
				return this.$Data.getExternalCompanyStations(0, 100).then(r => {
					this.managePopup.stations = _.orderBy(r.Results, ['Name']);
				}).finally(() => this.managePopup.loading--);
			},
			async getAffilaitedShows(pageIndex, limit) {
				return this.affiliatedShows.slice(pageIndex * limit, (pageIndex + 1) * limit);
			},
			isAffiliatedShow(show) {
				return this.affiliatedShows.some(f => f.Oid === show.Oid);
			},
			loadAffiliatedShows() {
				return this.$Data.getNetworkShowAffiliates(0, 9999).then(r => {
					this.affiliates = r?.Results || [];
					this.affiliatedShows = r?.Results?.map(f => f.NetworkShow);
				});
			},
			removeAffiliatedShow(show) {
				return this.$confirm(void 0, this.$tCaption('Do you want to remove \"SHOW_NAME\" from your account?').replace(/SHOW_NAME/g, show.Name)).then(() => {
					const idx = this.affiliatedShows.findIndex(f => f.Oid === show.Oid);
					if (idx >= 0) {
						this.affiliatedShows.splice(idx, 1);
					}
					const affiliateId = this.affiliates.find(f => f.NetworkShow.Oid === show.Oid)?.Oid;
					this.isLoading++;
					return this.$Data.deleteNetworkShowAffiliate(affiliateId).finally(() => this.isLoading--);
				});
			},
			affiliateShow(show) {
				this.$confirm(void 0, this.$tCaption('Do you want to add \"SHOW_NAME\" into your account?').replace(/SHOW_NAME/g, show.Name)).then(() => {
					this.isLoading++;
					this.$Data.createUpdateNetworkShowAffiliate({
						NetworkShow: {
							Oid: show.Oid
						},
						Owner: {
							Oid: this.$auth.companyId()
						}
					})
					.then((r) => {
						if (r.Success !== false) {
							this.affiliatedShows.push(show);
							this.affiliates.push(r?.Data);
							this.$notifySuccess(this.$tCaption('\"SHOW_NAME\" successfully added to your account').replace(/SHOW_NAME/g, show.Name));
						}
					})
					.finally(() => this.isLoading--);
				});
			},
			getReadableStringFromRRule(r) {
				return getReadableStringFromRRule(r, { until: false });
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--affiliated-shows--list {
		.show-item {
			transition: 0.3s;

			.show-logo {
				width: 48px;
				height: 48px;
				background: var(--img);
				background-position: center;
				background-size: cover;
				border-radius: 4px;
			}
		}

		.station {
			background: rgba(0,0,0,0.035);
			padding: 10px;
			border-radius: 4px;
		}
	}
</style>
